// extracted by mini-css-extract-plugin
export var activeFilterButton = "_h1-c";
export var backButton = "_h1-4";
export var backIcon = "_h1-5";
export var chevronShortcut = "_h1-6";
export var container = "_h1-1";
export var editor = "_h1-8";
export var editorWrapper = "_h1-7";
export var prefix = "_h1-2";
export var searchIcon = "_h1-3";
export var suffix = "_h1-9";
export var suffixContent = "_h1-a";
export var suffixText = "_h1-b";
export var wrapper = "_h1-0";